import React, { Component } from "react";
import { inject, observer } from 'mobx-react';
import { Button, ButtonType } from '@checkmarx/cx-ui'
import SearchBox from './searchBox';
import CheckboxList from '../portal/controls/checkboxList';
import { Scrollbars } from 'react-custom-scrollbars';
import IconComponent from './iconComponent';

@inject('translationsStore') @observer
export default class SelectableList extends Component {
    
    constructor(props) {
        super(props);

        var selectableList = this.createInitialList(props);
        this.state = { selectableList: selectableList };
    }

    componentWillMount() {
        this.props.onOpen();
    }

    componentWillUnmount()
    {
        this.props.onClose();
    }

    createInitialList = (props) => {
        
        let _this = this; 
        var list = [];
        props.data.forEach(function (item) {
            
            var isItemSelected = false;
            if(_this.isSelectedItemsInclude(props.selectedItemIds, item.id)){
                isItemSelected = true;
            }

            var selectableItem = {
                selected: isItemSelected,
                visible: true,
                itemData: item
            };
            
            list.push(selectableItem);
        });

        return list;
    }

    isSelectedItemsInclude = (selectedItemIds, itemId) => {
         if(selectedItemIds){
            for (var i = 0; i < selectedItemIds.length; i++) {
                if (selectedItemIds[i] === itemId) {
                    return true;
                }
            }
        }
        
        return false;
    }

    filterList = (searchText) => {
        
        if(searchText){

            searchText = searchText.trim().toLowerCase();
            
            this.state.selectableList.forEach(function (item) {

                if(item.itemData.name.toLowerCase().indexOf(searchText) == -1){
                    item.visible = false;
                    item.selected = false;
                }
                else{
                    item.visible = true;
                }
            });
        }
        else{
            
            this.state.selectableList.forEach(function (item) {
                item.visible = true;
            });
        }
        
        this.setUpdatedState();
    };

    saveSelectedItems = () => {
        
        var selectedItemIds = this.getSelectedIds(); 
        this.props.handleSaveSelectedItems(selectedItemIds);
    }

    getSelectedIds = () => {
        var selectedItemIds = this.state.selectableList.filter((item) => item.selected).map((item) => item.itemData.id);
        return selectedItemIds;
    }

    toggleItemSelection = (id) => {
        
        var items = this.state.selectableList.filter((item) => item.itemData.id === id);
        var item = items[0];
        item.selected = !item.selected;
        this.setUpdatedState();
    }

    setUpdatedState = () => {
        
        this.setState((prevState) => {
            return { 
                selectableList: prevState.selectableList
            }
        });
    }

    selectAll = () => {
        
        this.state.selectableList.filter((item) => item.visible).forEach(function (item) {
            item.selected = true;
        });
        
        this.setUpdatedState();
    }

    clearAll = () => {
        
        this.state.selectableList.filter((item) => item.visible).forEach(function (item) {
            item.selected = false;
        });
        
        this.setUpdatedState();
    }

    formatFullName = (fullName) => {
        
        var fullNameFormatted = fullName.substring(1).replace(new RegExp('/', 'g'), ' > ');
        return fullNameFormatted;
    }

    resetFilter = () => {
        
        this.clearAll();
        this.saveSelectedItems();
    }
	
	render() {

        const keywords = {
            searchLibrary: this.props.searchPlaceHolderTitle,
            clear: this.props.translationsStore.translate('CLEAR'),
        };
        
        return (
            <div className='selectable-list-container'>
                <div className='selectable-list-title selectable-list-content'>
                    <span className='filter-title'>{this.props.headerTitle}</span>
                    <IconComponent iconClassName="reset-icon" 
                        onClick={this.resetFilter} 
                        title={this.props.translationsStore.translate('RESET')}/>
                </div>

                {!this.props.hideSearch ? <SearchBox keywords={keywords} search={this.filterList}/> : null}

                <div className='selectable-items-container'>
                    <CheckboxList
                        height={this.props.height? this.props.height : 220}
                        rowHeight={this.props.rowHeight}
                        selectableList={this.state.selectableList}
                        formatAdditionalData={this.props.formatAdditionalData}
                        toggleSelection={this.toggleItemSelection} />
                </div>
                
                <div className='selectable-list-content selectable-list-buttons'>
                    <div className='selectable-list-links'>
                        <span className='portal-blank-button link' onClick={this.selectAll}>
                            { this.props.translationsStore.translate('SELECT_ALL') }
                        </span>
                        <span className='portal-blank-button link' onClick={this.clearAll}>
                            { this.props.translationsStore.translate('CLEAR') }
                        </span>
                    </div>
                    <div className='save-button'>
                        <Button 
                            onClick={this.saveSelectedItems}
                            text={this.props.submitLabel}>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}